
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import RequestHeader from "@/components/requests/RequestHeader.vue";
import TabsWithRoutes from "@/components/common/TabsWithRoutesNew.vue";
import GetRelativeRouteNameMixin from "@/mixins/route/GetRelativeRouteNameMixin.vue";
import { mixins } from "vue-class-component";
import RouteNames from "@/entities/RouteNames";
import RoutesNames from "@/entities/RouteTabs";
import RouteTabs from "@/entities/RouteTabs";
import DollarIcon from "@/components/icons/DollarIcon.vue";
import PageHeadIcon from "@/components/page/PageHeadIcon.vue"; 
import ExtendedTab from "@/components/common/ExtendedTab.vue";
import GET_CUSTOM_REQUEST from "@/apollo/requests/GET_CUSTOM_REQUEST.gql";
import SUBSCRIBE_CUSTOM_REQUEST from "@/apollo/requests/SubscribeCustomRequest.gql";
import GET_SUITABLE_RESOURCES_CONTRACTOR_AGGREGATE from "@/apollo/requests/GetSuitableResourcesContractorAggregate.gql";
import { Custom_Request, User, Company,Skill } from "@/generated/graphql";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import TabNotificationBubble from "@/components/common/TabNotificationBubble.vue";

interface RequestData {
    request?: Custom_Request;
    requestsTotal: number;
    // documentsCount: number;
    // contractorsCount: number;
    // requestsCount: number;
    // groupsCount: number;
  }

@Component({
  components: {
    TabsWithRoutes,
    RequestHeader,
    ExtendedTab, 
    PageHeadIcon,
    DollarIcon,
    LoadingOverlay,
    TabNotificationBubble
  },  
  apollo: {
    requestData: {
      query: GET_CUSTOM_REQUEST,
      variables() {
        const requestId = this.$route.params.id;
        return {
          id: requestId,
          currentUserId: this.currentUser.id
        };
      }, 
      update:(data)=>{
        return data;
      }
    },
    $subscribe: {
      requestData: {
        query: SUBSCRIBE_CUSTOM_REQUEST,
        variables() {
          const requestId = this.$route.params.id;
          return {
            id: requestId,
            currentUserId: this.currentUser.id
          };
        },
        update: (data) => {
          return data;
        }
      },
    }
  },
})
export default class Request extends Vue {
    // @Prop({ type: Object, required: true }) readonly company!: Company;
    // @Prop({ type: Object, required: true }) readonly currentUser!: User;
    
    routes: typeof RouteNames = RouteNames;
    processing: boolean = false;
    dialog: boolean = false;
    tabCountersQuerySkipped = true;

    requestData: any = [];
    currentUser: User = Vue.prototype.$currentUser;
    suggestedResourcesCount:string = "";

    created(): void {
      this.$root.$on('refetchRequest', () => {
        this.$apollo.queries.requestData.refetch();
      });
    }

    @Watch('requestData')
    async getSuggestedResourcesCount(): Promise<void> {
      if (!this.skillIds) {
        this.suggestedResourcesCount = "";
        return;
      }

      const exclude = !this.excludeResourceUserId ? {
        deleted: {
          _eq: false,
        }
      } : {
        id: {
          _neq: this.excludeResourceUserId,
        },
      };

      await this.$apollo.query({
        query: GET_SUITABLE_RESOURCES_CONTRACTOR_AGGREGATE,
        variables: {
          where: {
            _and: [
              exclude,
              {
                user: {
                  profile: {
                    skills: {
                      skill_id: {
                        _in: this.skillIds,
                      },
                    },
                  },
                }
              },
            ],
          },
        },
      }).then(result => {
        this.suggestedResourcesCount = "";
        if (result.data.contractor_aggregate.aggregate.count) {
          this.suggestedResourcesCount = "" + result.data.contractor_aggregate.aggregate.count;
        }
      });
    }

    get routeTabs(): RouteTabs {
      return {
        [RouteNames.CUSTOM_REQUESTS_RESOURCES_SUGGESTED]:`Suggested Resources`,
        [RouteNames.CUSTOM_REQUEST_DETAILS]: "details",
        [RouteNames.REQUEST_CONVERSATIONS]: `Messages`,
        [RouteNames.REQUEST_UPLOADS]: `Uploads`,
       
        // [RouteNames.PROJECT_GROUPS]: `groups (${this.projectData.groupsCount})`
      };
    }

    get skillIds(): number[] {
        return this.requestSkills.map(({ id }: Skill) => id);
      }

      get requestSkills(): Skill[] {
        let request:any = this.requests[0]
        return request.skills.map(({ skill }) => skill);
      }

      get excludeResourceUserId(): string {
        return this.requests[0].project_activity?.contractor?.user_id;
      }

    get requestsTotal():number {
      if(!this.requestData) {
        return 0;
      }
      return this.requestData.requestsTotal.aggregate.count;
    }

    get requests(): Custom_Request[] | [] {
      if (!this.requestData.requestData) {
        return undefined;
      }
      return this.requestData.requestData;
    }

    get requestDescription(): string {
      return this.requests[0].description;
    }
    refetchTabData(): void {
      this.$apollo.queries.tabCounters.refetch();
    }
    
    enableEditMode(): void {
      this.dialog = true;
    }

    disableEditMode(): void {
      this.dialog = false;
    }
    get role(): string {
      return "Admin";
    }
    get budget(): string {
      if (!this.requests) return "-";

      const { min_budget, max_budget } = this.requests[0]!;

      if (min_budget && max_budget) {
        return `Budget: $ ${min_budget}-${max_budget}`;
      }

      if (min_budget) {
        return `Budget: $ ${min_budget}`;
      }

      if (max_budget) {
        return `Budget: $ ${max_budget}`;
      }

      return "-";
    }

}
